import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DialogService } from '../../../dialog/dialog.service';
import { Document } from '../../../document-data/document.model';
import { BannerCanvasTypesEnum } from '../../../features-data/features-data.data';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { PaymentsSettings } from '../../../settings-data/sub-models/company-settings/payments.model';

@Component({
  selector: 'app-print-document-action',
  templateUrl: 'print-document-action.component.html',
  styleUrls: ['print-document-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintDocumentActionComponent implements OnInit, OnDestroy {
  @Input() document: Document;
  @Input() paymentSettings: PaymentsSettings;
  @Input() featureName: string;
  @Input() featureToggles: Toggles;

  @Output() onPrintDocument: EventEmitter<void> = new EventEmitter<void>();

  constructor(private _dialogService: DialogService) {}

  ngOnInit() {}

  printDocument() {
    if (!this.featureToggles.isAllAccess(this.featureName)) {
      this._dialogService.openGrowthDialog(
        BannerCanvasTypesEnum.feature_lock,
        this.featureName
      );
    } else {
      this.onPrintDocument.emit();
    }
  }

  ngOnDestroy() {
    this._dialogService.closeGrowthDialog(
      BannerCanvasTypesEnum.feature_lock,
      this.featureName
    );
  }
}
